var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  find = require('lodash/find');

// CRM uses this ID on professionInsuranceID to indicate that the bureau does not
// have any insurances.
var HAS_NO_INSURANCE = '3ce2f469-35f7-e111-aed5-0050568261bb'; // guid for external insurance

function BureauInsurances(params) {
  var self = this;

  self.aktorIdAgency = params.aktorIdAgency;
  self.API = params.api;
  self.texts = params.texts;
  self.hasExternalInsurance = ko.observable(false);
  self.hasProfessionInsuranceFromChainOffice = ko.observable(
    params.hasProfessionInsuranceFromChainOffice
  );
  self.hasCrimeInsuranceFromChainOffice = ko.observable(
    params.hasCrimeInsuranceFromChainOffice
  );
  var hasInsurance =
    params.hasProfessionInsurance || params.hasCriminalInsurance;
  self.showCrimeInsurance = ko.observable(false);
  if (params.hasExternalInsurance) {
    hasInsurance = false;
    self.hasExternalInsurance(true);
    self.showCrimeInsurance(self.shouldShowCrimeInsurance(hasInsurance, false));
  } else {
    self.showCrimeInsurance(
      self.shouldShowCrimeInsurance(params.hasProfessionInsurance, false)
    );
  }
  self.showProfessionInsuranceCheckbox = ko.observable(
    params.hasProfessionInsurance ? false : true
  );
  self.showCrimeInsuranceCheckbox = ko.observable(
    params.hasCriminalInsurance ? false : true
  );
  self.professionInsuranceValueIsSelected = ko.observable(false);

  // This is the object that contains insurance information that we will send and receive.
  self.storeObj = {
    AktorIdAgency: null,
    HeadCounts: 0,
    ProfessionInsuranceId: null,
    CriminalInsuranceId: null,
    TotalSalaryCost: 0,
    InsuranceSumProfessionInsurance: 0,
    InsuranceSumCrimeInsurance: 0
  };

  self.isLoadingUpdate = ko.observable(false);
  self.isSuccessfulUpdate = ko.observable(false);
  self.updateText = ko.observable('');

  self.professionInsurances = ko.observableArray();
  self.professionInsuranceId = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Du må velge ett av alternativene' }
    ]
  });

  self.isLoadingProfessionInsurances = ko.observable(false);

  self.criminalInsurances = ko.observableArray();
  self.criminalInsuranceId = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Du må velge ett av alternativene' }
    ]
  });

  self.headCount = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' },
      { type: 'isPositiveNumber', message: 'Det kan kun skrive inn tall' }
    ]
  });

  self.totalSalaryCost = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' },
      { type: 'isPositiveNumber', message: 'Det kan kun skrive inn tall' },
      {
        type: 'isLargerThan',
        message: 'Lønnskostnader må oppgis',
        threshold: 0
      }
    ]
  });

  self.professionInsuranceConfirmation = ko.observable(
    params.hasProfessionInsurance || false
  );
  self.crimeInsuranceConfirmation = ko.observable(
    params.hasCriminalInsurance || false
  );

  self.professionInsuranceConfirmation.subscribe(function(
    hasProfessionInsurance
  ) {
    self.showCrimeInsurance(
      self.shouldShowCrimeInsurance(
        hasInsurance || hasProfessionInsurance,
        false
      )
    );
    if (!hasProfessionInsurance) {
      self.professionInsuranceId(undefined);
    }
  });

  self.requiredFields = [self.headCount];

  self.updateRequestSent = ko.observable(false);

  self.getData();

  // We do not want to subscribe to the headCount until we have fetched existing data.
  self.headCount.subscribe(function() {
    self.getProfessionInsurances(false);
  });
}

BureauInsurances.prototype.shouldShowCrimeInsurance = function(
  hasInsurance,
  state
) {
  if (hasInsurance) {
    return true;
  } else {
    return state;
  }
};

BureauInsurances.prototype.getData = function() {
  this.getExistingData();
};

BureauInsurances.prototype.getExistingData = function() {
  var self = this,
    url =
      self.API.getInsuranceInformation + '?agencyAktorId=' + self.aktorIdAgency;

  APIHelper.get(
    url,
    function(data) {
      self.setExistingData(data);
      self.storeObj = data;
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: bureau-insurances.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

BureauInsurances.prototype.setExistingData = function(data) {
  this.totalSalaryCost(data.TotalSalaryCost);
  this.professionInsuranceId(data.ProfessionInsuranceId);
  if (this.professionInsuranceId() === HAS_NO_INSURANCE) {
    // Show the insurance box.
    this.showProfessionInsuranceCheckbox(true);
    // Set the checkbox to disabled.
    this.professionInsuranceConfirmation(false);
    this.hasExternalInsurance(true);
  } else {
    this.hasExternalInsurance(false);
  }
  this.criminalInsuranceId(data.CriminalInsuranceId);
  this.headCount(data.HeadCounts);
  this.getCrimeInsurances();
};

BureauInsurances.prototype.getProfessionInsurances = function() {
  var self = this,
    url =
      self.API.getProfessionInsurances +
      '?headCounts=' +
      self
        .headCount()
        .toString()
        .replace(',', '.');

  self.isLoadingProfessionInsurances(true);
  APIHelper.get(
    url,
    function(data) {
      self.professionInsurances(data);
      // Check to see if the chosen item is in the list.
      var tempProfId = '';
      find(data, function(o) {
        if (o.InsuranceId === self.professionInsuranceId()) {
          tempProfId = o.InsuranceId;
          return true;
        }
        return false;
      });
      self.professionInsuranceId(tempProfId);
      self.isLoadingProfessionInsurances(false);
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: bureau-insurances.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

BureauInsurances.prototype.getCrimeInsurances = function() {
  var self = this,
    url = self.API.getCriminalInsurances;

  APIHelper.get(
    url,
    function(data) {
      self.criminalInsurances(data);
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: bureau-insurances.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

BureauInsurances.prototype.validateFields = function(fields) {
  var isValid = true;
  for (var i = 0; i < fields.length; i++) {
    if (fields[i]() === undefined || fields[i]() === null) {
      fields[i].hasError(true);
    }
    if (fields[i].hasError()) {
      isValid = false;
    }
  }

  return isValid;
};

BureauInsurances.prototype.createStoreObj = function() {
  this.storeObj.HeadCounts = this.headCount()
    .toString()
    .replace(',', '.');
  if (
    this.professionInsuranceId() !== undefined &&
    this.professionInsuranceId() !== null
  ) {
    this.storeObj.ProfessionInsuranceId = this.professionInsuranceId().toString();
  }
  // Only update crime insurance stuff if the checkbox is active (or bureau already has crime insurance).
  if (this.crimeInsuranceConfirmation()) {
    if (
      this.totalSalaryCost() !== undefined &&
      this.totalSalaryCost() !== null
    ) {
      this.storeObj.TotalSalaryCost = parseInt(this.totalSalaryCost(), 10);
    }
    if (
      this.criminalInsuranceId() !== undefined &&
      this.criminalInsuranceId() !== null
    ) {
      if (this.criminalInsuranceId() !== undefined) {
        this.storeObj.CriminalInsuranceId = this.criminalInsuranceId().toString();
      }
    }
  }

  return this.storeObj;
};

BureauInsurances.prototype.closeUpdateRequestSent = function() {
  this.updateRequestSent(false);
};

BureauInsurances.prototype.updateInsurances = function() {
  // Don't update if totalSalaryCost is not a positive number.
  if (
    this.crimeInsuranceConfirmation() &&
    parseInt(this.totalSalaryCost(), 10) <= 0
  ) {
    this.updateRequestSent(true);
    this.isSuccessfulUpdate(false);
    this.updateText(this.texts.totalSalaryCostErrorText);
    return;
  }
  // CrimeInsuranceId must be set if user has chosen to have criminal insurance.
  if (this.crimeInsuranceConfirmation()) {
    this.requiredFields = [
      this.headCount,
      this.professionInsuranceId,
      this.totalSalaryCost,
      this.criminalInsuranceId
    ];
  } else {
    this.requiredFields = [this.headCount];
  }
  if (!this.validateFields(this.requiredFields)) {
    return;
  }

  var self = this,
    url = self.API.addOrUpdateInsuranceAndEmployees,
    data = self.createStoreObj();

  self.isLoadingUpdate(true);
  APIHelper.post(
    url,
    data,
    function(response) {
      self.updateRequestSent(true);
      self.isLoadingUpdate(false);
      self.isSuccessfulUpdate(true);
      self.updateText(response);
    },
    function() {
      self.updateRequestSent(true);
      self.isLoadingUpdate(false);
      self.isSuccessfulUpdate(false);
      self.updateText(self.texts.errorText);
    }
  );
};

module.exports = BureauInsurances;
